import SportsIndex from "./SportsIndex";
export default SportsIndex;
